export const capitalizeFirstLetter = (string: string) =>
  string.charAt(0)?.toUpperCase() + string.slice(1);

export const decapitalizeFirstLetter = (string: string) =>
  string.charAt(0)?.toLowerCase() + string.slice(1);

export const replaceDestinationSpace = (string: string) =>
  string.replaceAll(' ', '_');

export const replaceDestinationWithSpace = (string: string) =>
  string.replaceAll('_', ' ');
